import styled from 'styled-components';

export const WeekdayContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const WeekdayBubble = styled.div<{ $selected: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${({ theme }) => theme.white.a10};
  height: 26px;
  width: 26px;
  font-size: 12px;
  margin-right: 5px;
  border-radius: 50%;
  background-color: ${({ theme, $selected }) => ($selected ? theme.baseBlue.a10 : theme.baseBlue.a6)};
  transition: all 150ms ease-in-out;
  cursor: pointer;
`;
